<template>
  <div class="app_container">
    <el-tabs v-model="moduleType" tab-position="left"  @tab-click="handleModuleTypeClick" lazy>
      <el-tab-pane label="特色内容" name="1" v-if="showFeature ">
        <FeatureContent v-if=" moduleType == '1'" :actionType="actionType"/>
      </el-tab-pane>
      <el-tab-pane label="活动专区" name="2" >
        <ActivityContent v-if=" moduleType == '2'" :actionType="actionType"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import FeatureContent from "./featureContent/index.vue"
import ActivityContent from "./activityContent/index.vue"
export default {
  name: "homeConfig",
  components: {
    FeatureContent,
    ActivityContent
  },
  props:{
    showFeature: {
      type: Boolean,
      default: false
    },
    actionType:{
      type:String,
      default:'1'
    }
  },
  data() {
    return {
      moduleType: '2',
    };
  },
  created() {
    if (this.showFeature) {
      this.moduleType = '1'
    }
  },
  mounted() {},
  methods: {
    handleModuleTypeClick() {

    },
  }
};
</script>

<style lang="scss" scoped>

</style>
